import React from "react";
import {useDrag} from "react-dnd";

const ModeratorRoleItem = props => {
    const [, drag] = useDrag(() => ({
            item: {
                id: props.id,
                uuid: props.uuid,
                role: props.role,
                type: "role-drop",
            },
            collect: (monitor) => ({
                isDragging: !!monitor.isDragging()
            })
        })
        , [props.role, "role-drop"]);

    return <div className='moderator-player-card-role-container' style={{cursor: "move"}} ref={drag}>
        {props.content ?? ""}
    </div>;
}

export default ModeratorRoleItem;
